import { render } from "./AutoTopupActivationMPayLandingError.vue?vue&type=template&id=e1d59cf6&scoped=true"
import script from "./AutoTopupActivationMPayLandingError.vue?vue&type=script&lang=js"
export * from "./AutoTopupActivationMPayLandingError.vue?vue&type=script&lang=js"

import "./AutoTopupActivationMPayLandingError.vue?vue&type=style&index=0&id=e1d59cf6&scoped=true&lang=scss"

import exportComponent from "/appl/bamboo/bamboo-agent-home-5/xml-data/build-dir/PORTAL-DREITVWEBUI-JOB1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1d59cf6"]])

export default __exports__